import React, { Component } from 'react'
import { connect } from 'react-redux'
// import ReactDOM from 'react-dom'
// import { GetDataWarehouse } from '../../../actions/shops'
import { hasSubscriptionPermission } from '../../../utils/auth'
import { API_BASE } from '../../../constants'

import './dwhouse.scss'

const REPORT_URLS = ['GetShop', 'GetChain']

class DWHouse extends Component {
  // Implementation notes:
  // -  Doesn't work correctly when getting from api and setting content in iframe (powerbi scripts doesn't initialize)
  // -  Have to let iframe get content through src, which means we can not include the additional headers we send with all other API calls (such as authentication token)
  //    For that reason, the auth token is included as url parameter and must also be handled on the API side.

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 30, 10)) return null
    return (
      <div className='dw-house'>
        <iframe src={API_BASE + '/DataWarehouse/' + REPORT_URLS[this.props.reportType] + '?authToken=' + encodeURIComponent(this.props.auth.user.Token)} />
      </div>
    )
  }
}

DWHouse.defaultProps = {
  reportType: 0
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  // GetDataWarehouse
})(DWHouse)



// WEBPACK FOOTER //
// ./src/app/shared/components/DWHouse/index.js